module.exports = __webpack_public_path__ + "img/1436790398.18b12606.jpg";